import { useState } from 'react';

import { useEffectOnMount } from '../../../../hooks';

export const useMountAnimation = (): boolean => {
  const [mounted, setMounted] = useState(false);
  useEffectOnMount(() => {
    setMounted(true);
  });
  return mounted;
};
